import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { collectViewportToolsetRailRendererResults } from "@/viewport-tools/rail/renderers";
import type { ViewportToolsetsRailProps } from "@/viewport-tools/rail/types";

export function ViewportToolsetsHeader({
  enabledToolsets,
  controllers,
}: ViewportToolsetsRailProps) {
  const items = collectViewportToolsetRailRendererResults(
    enabledToolsets ?? [],
    controllers
  ).flatMap((result) => (result.item ? [result.item] : []));

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-1">
      {items.map((item) => (
        <Button
          key={item.id}
          type="button"
          variant="ghost"
          size="sm"
          disabled={item.disabled}
          aria-pressed={Boolean(item.active || item.selected)}
          onClick={item.onClick}
          className={cn(
            "h-9 gap-1.5 rounded-none border-0 bg-transparent px-2.5 text-[10px] font-semibold uppercase tracking-[0.1em] text-muted-foreground shadow-none transition-colors hover:bg-muted/30 hover:text-foreground",
            (item.active || item.selected) &&
              "bg-foreground text-background hover:bg-foreground/90 hover:text-background",
            item.selected && !item.active && "bg-muted/70 text-foreground"
          )}
        >
          <span className="flex items-center justify-center">{item.icon}</span>
          <span>{item.label}</span>
        </Button>
      ))}
    </div>
  );
}
